export default __webpack_public_path__ + "static/media/element_spec_38.9e4a4075.webp";